import React from 'react';

// Canonical company lists — keep these as the single source of truth so the
// data never drifts into free-text variants again.
export const TECH_CHECK_COMPANIES = ['SICTA', 'MAYELIA', 'SILOTEC CI'];
export const INSURANCE_COMPANIES = [
  'NSIA', 'SUNU', 'LEADWAY', 'ATLANTIQUE', 'AXA', 'SAHAM', 'AMSA', 'ALLIANZ', 'SAAR', 'COLINA',
];

/**
 * Dropdown for a company field. Strict list by default; pass allowOther to add
 * an "Autre..." option that reveals a free-text input (used for insurance,
 * which has many companies). Tech-check is strict — only the centres listed in
 * TECH_CHECK_COMPANIES above are selectable.
 */
export default function CompanySelect({
  value,
  onChange,
  options,
  allowOther = false,
  className = '',
  // The "Autre..." free-text box needs its own class: `className` may carry a
  // <select>-only chevron background, which looks wrong on a text input.
  inputClassName,
  placeholder = 'Sélectionner...',
}) {
  const inList = value && options.includes(value);
  const isOther = allowOther && value && !inList;
  const selectValue = inList ? value : (isOther ? '__other__' : '');

  return (
    <>
      <select
        value={selectValue}
        onChange={(e) => {
          const v = e.target.value;
          onChange(v === '__other__' ? '' : v);
        }}
        className={className}
      >
        <option value="">{placeholder}</option>
        {options.map((o) => <option key={o} value={o}>{o}</option>)}
        {allowOther && <option value="__other__">Autre...</option>}
      </select>
      {allowOther && (selectValue === '__other__' || isOther) && (
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Nom de la compagnie"
          className={`${inputClassName || className} mt-2`}
        />
      )}
    </>
  );
}
